import { Flex } from '@chakra-ui/react';
import RoleToggleItem from './RoleToggleItem';
import {
  MdOutlinePeople, 
  MdHandshake
} from 'react-icons/md'
import { useTranslation } from 'i18n/TranslationProvider';
const RoleToggle = () => {
  const { t } = useTranslation(); 

  return (
    <Flex
      gap={{ base: 3, md: 4 }}
      direction={{ base: 'column', sm: 'row' }}
      w="100%"
      align="stretch"
    >
      <RoleToggleItem icon={MdOutlinePeople} title={t('auth.client')} value="client" description={t('auth.order_transportation_in_the_automotive_branch')} />
      <RoleToggleItem icon={MdHandshake} title={t('auth.partner')} value="partner" description={t('auth.join_our_network_of_transport_partners')} />
    </Flex>
  );
};

export default RoleToggle;
